import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const fields = ({ t }) => [
  {
    type: "section",
    title: t("forms.contact.information"),
    fields: contactFields({ t }),
  },
  {
    type: "section",
    title: t("forms.feedback.title"),
    fields: [
      {
        key: "rating",
        label: t("forms.feedback.rating"),
        type: "optionButtons",
        helpText: t("forms.feedback.help"),
        required: true,
        inputProps: {
          buttonStyle: "circle",
          wrap: true,
          numeric: true,
          options: [
            {
              value: "1",
              color: "red",
            },
            {
              value: "2",
              color: "orange",
            },
            {
              value: "3",
              color: "yellow",
            },
            {
              value: "4",
              color: "blue",
            },
            {
              value: "5",
              color: "green",
            },
          ],
        },
      },
      {
        key: "recommend",
        label: t("forms.feedback.recommend"),
        type: "optionButtons",
        required: true,
        inputProps: {
          wrap: true,
          options: [
            {
              value: "yes",
              label: t("forms.feedback.yes"),
            },
            {
              value: "no",
              label: t("forms.feedback.no"),
            },
            {
              value: "maybe",
              label: t("forms.feedback.maybe"),
            },
            {
              value: "alreadyHave",
              label: t("forms.feedback.did"),
            },
          ],
        },
      },
      {
        key: "comments",
        label: t("forms.feedback.comments"),
        type: "textarea",
        required: true,
        inputProps: {
          minRows: 4,
        },
      },
    ],
  },
];

const ContactForm = ({ moduleKey }) => (
  <DynamicForm
    formKey={moduleKey}
    fields={fields}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/FeedbackForm.js